<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span class="pointer" @click="redirectPath">Leads</span>
                            <div class="pointer" @click="redirectPath">{{lead_type}}</div>
                            <div>View Lead</div>
                        </div>
                    </div>
                </div>
            </h2>
            <!-- <div class="d-flex">
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'lead_info','new-blue':active_tab == 'lead_info'}" @click="switchTabs('lead_info')">
                    <span class="text-capitalize">Lead Info</span>
                </div>
                <div class="slant-tabs ml-2" :class="{'activeTab':active_tab == 'qualifying_lead','new-blue':active_tab == 'qualifying_lead'}" @click="switchTabs('qualifying_lead')">
                    <span class="text-capitalize">Interaction</span>
                </div>
                <div class="slant-tabs ml-2" :class="{'activeTab':active_tab == 'lead_interaction','new-blue':active_tab == 'lead_interaction'}" @click="switchTabs('lead_interaction')">
                    <span class="text-capitalize">Activity Log </span>
                </div>
                <div class="btn-position">
                    <button class="btn btn-new-success btn-wide mr-1 pr-4 pl-7" v-if="this.lead_type == 'Archive' && active_tab == 'qualifying_lead' && userPermissions.leads.permitted_actions.retrieve" @click="archiveConfirm(selectLeads)"><i class="icon icon-send icon-direction text-white mr-2 fs-14"></i>Send To Active Leads</button>
                </div>
            </div> -->
            <!-- Tabs Section -->
            <div class="tabs tabs-style-shape">
                <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                    <defs>
                        <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                    </defs>
                </svg>
                <nav>
                    <ul class="ml-0">
                        <li :class="{'tab-current':active_tab == 'lead_info'}">
                            <a href="javascript:;" @click="switchTabs('lead_info')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span>Lead Info</span>
                            </a>
                        </li>
                        <li :class="{'tab-current':active_tab == 'qualifying_lead'}">
                            <a href="javascript:;" @click="switchTabs('qualifying_lead')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span style="border-radius: 30px 0 0 0;">Interaction</span>
                            </a>
                        </li>
                        <li :class="{'tab-current':active_tab == 'lead_interaction'}">
                            <a href="javascript:;" @click="switchTabs('lead_interaction')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span style="border-radius: 30px 0 0 0;">Activity Log</span>
                            </a>
                        </li>
                        <!-- For styling we need this tag  -->
                        <li style="width: 0px !important;flex: 0 !important;">
                            <a href="#section-shape-3" style="margin: 0">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <lead-info @updateLeadData="updateLeadData" v-if="lead_info"></lead-info>
            <qualifying-lead :lead_data="lead_data" v-if="qualifying_lead"></qualifying-lead>
            <lead-interaction v-if="lead_interaction"></lead-interaction>
            <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
            <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
            <archive-modal modal_name="archiveModal" @archiveData="archiveData" @cancelArchive="cancelArchive" :active_status="'Retrieve'"></archive-modal>
        </div>
    </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue';
const LeadInfo = () => import("./LeadInfo");
const QualifyingLead = () => import("./QualifyingLead");
const LeadInteraction = () => import("./LeadInteraction");
import ArchiveModal from "../alertModals/ArchiveModal";
import leads from "../mixins/leads";
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    data(){
        return{
            warning_msg: '',
            success_msg: '',
            active_tab: 'qualifying_lead',
            lead_info: false,
            qualifying_lead: true,
            lead_interaction: false,
            lead_data: null,
            lead_type: "",
            selectLeads:[],
        }
    },
    mixins:[leads],
    methods:{
        //redirecting the route from view to list lead
        redirectPath(){
            localStorage.setItem('list_leads_redirection', this.lead_type)
            this.$router.push("/listleads")
        },
        //swtich the tabs between lead info, interaction & activity log
        switchTabs (obj){
            if(obj == 'lead_info'){
                this.active_tab = 'lead_info'
                this.lead_info = true
                this.qualifying_lead = false
                this.lead_interaction = false
            }
            else if(obj == 'qualifying_lead'){
                this.active_tab = 'qualifying_lead'
                this.lead_info = false
                this.qualifying_lead = true
                this.lead_interaction = false
            }
            else if(obj == 'lead_interaction'){
                this.active_tab = 'lead_interaction'
                this.lead_info = false
                this.qualifying_lead = false
                this.lead_interaction = true
            }
        },
        //checking the lead is archived  or not , to retrive
        archiveConfirm() {
            EventBus.$emit("archive_status",'retrieve')
            this.$modal.show('archiveModal')
        },
        //updating the lead's data
        /**@params = value*/
        updateLeadData(value){
            this.lead_data = value
            this.selectLeads.push(this.lead_data.id)
        },
        //archive the selected data
        /**@params = id*/
        async archiveData(){
            let params = {
                ids: [this.$route.params.id]
            }
            let response = await this.convertRetrieveLeads(params)
            this.success_msg = "Leads Reverted to Manual Successfully"
            this.$refs.success_modal.open();
            setTimeout(() => {
                //this.id = []
                this.$refs.success_modal.close();
            }, 3000);
            this.$router.push("/listleads");
        },
        //cancel archive modal
        cancelArchive(){
            this.selectLeads = []
        },

    },
    components:{
        LeadInfo,
        QualifyingLead,
        LeadInteraction,
        SweetModal,
        ArchiveModal
    },
    mounted(){
        this.lead_type = localStorage.getItem("leads_type")
        EventBus.$on("selectId",(value) => {
            let selectedLeads = value

        })
    },
    computed: {
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
    },
}
</script>
<style scoped>
    .btn-new-success {
        background-color: #008a63;
    }
    .btn-position {
        align-items: end;
        margin-left: auto;
    }
    .icon-direction {
        transform: translate(-60%,20%) scale(1) rotate(320deg);
        position: absolute;
        left:20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Leads/ViewLeads.vue